module.exports = __webpack_public_path__ + "img/Man-6.7fe02481.svg";